import React, { useEffect, useState } from "react";
import Header from "../../../../Componets/Header";
import TableImage from "../../../../Componets/Image";
import Status from "../../../../Componets/Status";
import ActionButton from "../../../../Componets/Buttons/action";
import { get_all_project_jobs } from "../../../../Controllers/Projects/Jobs";
import toast from "react-hot-toast";
import tables from "../../../../Data/Tables/Projects/Jobs/tables";
import headers from "../../../../Data/Tables/Projects/Jobs/headers";
import Loadercomponent from "../../../../Componets/Loader";
import { useParams } from "react-router-dom";
import Table from "../../../../Componets/Table";
import Progresscircle from "../../../../Componets/Progress";
import Projectsjobstabs from "../../../../Data/Tables/Projects/Jobs/tabs";
import URL from "../../../../Main/url";

const ProjectsjobsTable = () => {
  const { project } = useParams();

  headers.components[
    headers?.components?.length - 1
  ].path = `/app/projects/jobs/add/${project}`;

  const [loader, setLoader] = useState(false);
  const [body, setBody] = useState();
  const [projectData, setProjectData] = useState();
  const [header, setHeader] = useState(headers);

  const formdata = (data) => {
    fetchData(data);
  };

  const actiondata = (data) => {
    fetchData(data);
  };

  const fetchData = async (tabledata) => {
    try {
      setLoader(true);

      const data = {
        project: project,
        search: tabledata?.search,
        sort: tabledata?.sort,
        customer: tabledata?.customer,
        project_status: tabledata?.project_status,
        start_date: tabledata?.start_date,
        end_date: tabledata?.end_date,
        status: tabledata?.status,
      };

      const projects = await get_all_project_jobs(data);
      if (projects?.status) {
        let data = [];

        console.log(projects?.data?.jobs, "projects?.data?.jobs");

        projects?.data?.jobs?.map((value, index) => {
          data?.push({
            _id: value?._id,
            Name: <TableImage image={value?.image} name={value?.name} />,
            Number: `#JOB${value?.number}`,
            "Est.expense": value?.estimated_expenses
              ? value?.estimated_expenses?.toFixed?.(3)
              : "0.000",
            Expense: value?.expense,
            Progress: <Progresscircle percentage={value?.progress} />,
            Status: <Status status={value?.status} />,
            Action: (
              <ActionButton
                edit={`/app/projects/jobs/edit/${project}/${value?._id}`}
                id={value?._id}
                api="delete-job"
                actiondata={actiondata}
              />
            ),
          });
        });

        setBody(data);
        setProjectData(projects?.data?.project);
        setLoader(false);
      } else {
        toast?.error(projects?.message);
        setLoader(false);
      }
    } catch (errors) {
      toast?.error(errors?.message);
    }
  };

  useEffect(() => {
    fetchData();
  }, []);

  return (
    <Header headers={header} setHeaders={setHeader} formdata={formdata}>
      <Loadercomponent loader={loader}>
        <Projectsjobstabs projectData={projectData} />
        <Table head={tables} body={body} />
      </Loadercomponent>
    </Header>
  );
};

export default ProjectsjobsTable;
